// import React, { useEffect, useState } from "react";
// import { ChevronDown, MapPin } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const ProjectsList = () => {
//   // const [selectedFilter, setSelectedFilter] = useState("All");
//   const navigate = useNavigate();
//   const [projects, setProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const allProjects = async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       let config = {
//         method: "get",
//         maxBodyLength: Infinity,
//         url: `${process.env.REACT_APP_API_URL}/projects/all-projects`,
//         headers: {},
//       };

//       const response = await axios.request(config);
//       console.log("API Response:", response.data);

//       const transformedProjects = response.data.map((project) => ({
//         id: project._id,
//         title: project.projectName,
//         images: project.images,
//         location: project.location,
//         description: project.description,
//         amenities: project.amenities,
//         specifications: project.specifications,
//         extraFacilities: project.extraFacilities,
//         popularPlaces: project.popularPlaces,

//         createdAt: project.createdAt,
//         updatedAt: project.updatedAt,
//       }));

//       setProjects(transformedProjects);
//     } catch (error) {
//       console.error("Error fetching projects:", error);
//       setError("Failed to fetch projects. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     allProjects();
//   }, []);

//   const ProjectCard = ({ project }) => (
//     <div
//       onClick={() => {
//         navigate(`/projects/project-details/${project.id}`);
//       }}
//       className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300 cursor-pointer"
//     >
//       <div className="relative h-48 sm:h-52 md:h-56 lg:h-48 xl:h-52 overflow-hidden">
//         <img
//           src={
//             project.images && project.images.length > 0
//               ? project.images[0]
//               : project.projectName
//           }
//           alt={project.title}
//           className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
//         />
//       </div>

//       <div className="p-4">
//         <h3 className="font-semibold text-gray-900 text-sm md:text-base mb-2 line-clamp-2">
//           {project.title}
//         </h3>
//         <div className="flex items-start text-gray-600 text-xs md:text-sm">
//           <MapPin className="w-3 h-3 md:w-4 md:h-4 mr-1.5 text-red-500 flex-shrink-0 mt-0.5" />
//           <span className="line-clamp-2">{project.location}</span>
//         </div>

//         {project.amenities && project.amenities.length > 0 && (
//           <div className="mt-2 text-xs text-gray-500">
//             {project.amenities.length} amenities
//           </div>
//         )}
//       </div>
//     </div>
//   );

//   const SkeletonCard = () => (
//     <div className="bg-white rounded-lg overflow-hidden shadow-sm">
//       {" "}
//       <div className="h-48 sm:h-52 md:h-56 lg:h-48 xl:h-52 bg-gray-200 animate-pulse"></div>
//       <div className="p-4">
//         <div className="h-4 bg-gray-200 rounded animate-pulse mb-2"></div>
//         <div className="h-4 bg-gray-200 rounded animate-pulse mb-3 w-3/4"></div>

//         <div className="flex items-center">
//           <div className="w-4 h-4 bg-gray-200 rounded animate-pulse mr-1.5"></div>
//           <div className="h-3 bg-gray-200 rounded animate-pulse w-2/3"></div>
//         </div>

//         <div className="mt-2 h-3 bg-gray-200 rounded animate-pulse w-1/3"></div>
//       </div>
//     </div>
//   );

//   if (loading) {
//     return (
//       <div className="bg-gray-50 min-h-screen py-6 px-4 sm:px-6 lg:px-8">
//         <div className="w-full mx-auto">
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 md:mb-8">
//             <div className="h-8 bg-gray-200 rounded animate-pulse w-32 mb-4 sm:mb-0"></div>
//             <div className="h-10 bg-gray-200 rounded animate-pulse w-24"></div>
//           </div>

//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
//             {[...Array(8)].map((_, index) => (
//               <SkeletonCard key={index} />
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="bg-gray-50 min-h-screen py-6 px-4 sm:px-6 lg:px-8">
//         <div className="max-w-7xl mx-auto">
//           <div className="flex flex-col items-center justify-center h-64">
//             <div className="text-lg text-red-600 mb-4">{error}</div>
//             <button
//               onClick={allProjects}
//               className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
//             >
//               Retry
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-gray-50 min-h-screen py-6 px-4 sm:px-6 lg:px-8">
//       <div className="w-full mx-auto">
//         <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 md:mb-8">
//           <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 sm:mb-0">
//             Projects {projects.length > 0 && `(${projects.length})`}
//           </h1>

//           {/* <div className="relative">
//             <button
//               className="bg-white border border-gray-300 rounded-lg px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent min-w-[100px] flex items-center justify-between"
//               onClick={() => {}}
//             >
//               <span>{selectedFilter}</span>
//               <ChevronDown className="w-4 h-4 ml-2" />
//             </button>
//           </div> */}
//         </div>

//         {projects.length === 0 ? (
//           <div className="text-center py-12">
//             <div className="text-gray-500 text-lg">No projects found</div>
//           </div>
//         ) : (
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
//             {projects.map((project) => (
//               <ProjectCard key={project.id} project={project} />
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ProjectsList;

import React, { useEffect, useState } from "react";
import { ChevronDown, MapPin } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ProjectsList = () => {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isUserAuthenticated = () => {
    const userData = localStorage.getItem("userData");

    if (!userData) {
      return false;
    }

    try {
      const parsedUserData = JSON.parse(userData);

      const requiredFields = ["id", "email", "name", "phoneNumber"];
      const hasAllFields = requiredFields.every(
        (field) => parsedUserData[field] && parsedUserData[field].trim() !== ""
      );

      return hasAllFields;
    } catch (error) {
      console.error("Error parsing userData from localStorage:", error);
      return false;
    }
  };

  const handleProjectClick = (projectId) => {
    const isAuthenticated = isUserAuthenticated();

    if (isAuthenticated) {
      navigate(`/projects/project-details/${projectId}`);
    } else {
      navigate("/user-login");
    }
  };

  const allProjects = async () => {
    try {
      setLoading(true);
      setError(null);

      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/projects/all-projects`,
        headers: {},
      };

      const response = await axios.request(config);
      console.log("API Response:", response.data);

      const transformedProjects = response.data.map((project) => ({
        id: project._id,
        title: project.projectName,
        images: project.images,
        location: project.location,
        description: project.description,
        amenities: project.amenities,
        specifications: project.specifications,
        extraFacilities: project.extraFacilities,
        popularPlaces: project.popularPlaces,
        createdAt: project.createdAt,
        updatedAt: project.updatedAt,
      }));

      setProjects(transformedProjects);
    } catch (error) {
      console.error("Error fetching projects:", error);
      setError("Failed to fetch projects. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    allProjects();
  }, []);

  const ProjectCard = ({ project }) => (
    <div
      onClick={() => handleProjectClick(project.id)}
      className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300 cursor-pointer"
    >
      <div className="relative h-48 sm:h-52 md:h-56 lg:h-48 xl:h-52 overflow-hidden">
        <img
          src={
            project.images && project.images.length > 0
              ? project.images[0]
              : project.projectName
          }
          alt={project.title}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
        />
      </div>

      <div className="p-4">
        <h3 className="font-semibold text-gray-900 text-sm md:text-base mb-2 line-clamp-2">
          {project.title}
        </h3>
        <div className="flex items-start text-gray-600 text-xs md:text-sm">
          <MapPin className="w-3 h-3 md:w-4 md:h-4 mr-1.5 text-red-500 flex-shrink-0 mt-0.5" />
          <span className="line-clamp-2">{project.location}</span>
        </div>

        {project.amenities && project.amenities.length > 0 && (
          <div className="mt-2 text-xs text-gray-500">
            {project.amenities.length} amenities
          </div>
        )}
      </div>
    </div>
  );

  const SkeletonCard = () => (
    <div className="bg-white rounded-lg overflow-hidden shadow-sm">
      <div className="h-48 sm:h-52 md:h-56 lg:h-48 xl:h-52 bg-gray-200 animate-pulse"></div>
      <div className="p-4">
        <div className="h-4 bg-gray-200 rounded animate-pulse mb-2"></div>
        <div className="h-4 bg-gray-200 rounded animate-pulse mb-3 w-3/4"></div>

        <div className="flex items-center">
          <div className="w-4 h-4 bg-gray-200 rounded animate-pulse mr-1.5"></div>
          <div className="h-3 bg-gray-200 rounded animate-pulse w-2/3"></div>
        </div>

        <div className="mt-2 h-3 bg-gray-200 rounded animate-pulse w-1/3"></div>
      </div>
    </div>
  );

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen py-6 px-4 sm:px-6 lg:px-8">
        <div className="w-full mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 md:mb-8">
            <div className="h-8 bg-gray-200 rounded animate-pulse w-32 mb-4 sm:mb-0"></div>
            <div className="h-10 bg-gray-200 rounded animate-pulse w-24"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
            {[...Array(8)].map((_, index) => (
              <SkeletonCard key={index} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-gray-50 min-h-screen py-6 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col items-center justify-center h-64">
            <div className="text-lg text-red-600 mb-4">{error}</div>
            <button
              onClick={allProjects}
              className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
            >
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen py-6 px-4 sm:px-6 lg:px-8">
      <div className="w-full mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 md:mb-8">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 sm:mb-0">
            Projects {projects.length > 0 && `(${projects.length})`}
          </h1>
        </div>

        {projects.length === 0 ? (
          <div className="text-center py-12">
            <div className="text-gray-500 text-lg">No projects found</div>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
            {projects.map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectsList;
